/* @jsxImportSource react */

export type SelectedInstallmentDisplayProps = {
  /**
   * the selected installment value
   */
  selectedInstallment: number;
  /**
   * the unit of the installment
   */
  unit: string;
};

/**
 * installment price atom
 *
 * atom to display the calculated installment price
 *
 * */
export const SelectedInstallmentDisplay = ({
  selectedInstallment,
  unit,
}: SelectedInstallmentDisplayProps) => (
  <div className="flex flex-col items-center">
    <div className="text-size-h4 mb-0.5">{unit}</div>
    <h1 className="text-size-h1">{selectedInstallment}</h1>
  </div>
);
